import { Box, Typography } from "@mui/material";

import { VisitPossibility } from "../../types/ProtocolTypes";

type Props = {
    color: string;
    yearLength: number;
    possibleVisit: VisitPossibility;
};

export default function PossibleVisitIndicator({ color, yearLength, possibleVisit }: Props) {
    const startPercent = (possibleVisit.start / yearLength) * 100;
    const endPercent = ((possibleVisit.end - possibleVisit.start) / yearLength) * 100;
    return (
        <Box
            sx={{
                height: "100%",
                width: `${endPercent}%`,
                left: `${startPercent}%`,
                position: "absolute",
                background: color,
            }}
        >
            <Typography variant="caption">{possibleVisit.end - possibleVisit.start}</Typography>
        </Box>
    );
}
